import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { PAGE_NOT_FOUND } from '@symphony-solo/shared/utils/src';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  
  constructor(private injector: Injector) {}
  
  public handleError(error) {

    const router = this.injector.get(Router);

    // Check if the error is related to route matching
    if (error?.rejection?.message && error.rejection.message.includes('Cannot match any routes')) {
      // Redirect to the 404 page
      router.navigate([PAGE_NOT_FOUND]);
    }

    // your custom error handling logic
    console.log('error handler:' + error);
  }
}
